import { mutations } from "@/constants/state";

export default {
  [mutations.DOMAIN_FETCH_MUTATION]: (state, payload) => {
    state.domain = payload;
  },
  [mutations.JOIN_DINNER_FETCH_MUTATION]: (state, payload) => {
    state.domain = {
      ...state.domain,
      join_dinner_range: payload.join_dinner_range,
      is_join_dinner_enabled: payload.is_join_dinner_enabled
    };
  },
};
